import { Component, input } from '@angular/core';
import { StatusSidebar } from '@app/shared/components/status-sidebar/status-sidebar';
import { RequestService } from '../../projects.service';


@Component({
  selector: 'app-request-status',
  imports: [StatusSidebar],
  templateUrl: './request-status.html',
  styleUrl: './request-status.scss'
})
export class RequestStatus {
  requestId = input<string | null>(null);
  
  // Configuration for request status
  requestConfig = {
    type: 'request' as const,
    title: 'Manage Request',
    statusLabel: 'Status',
    assignLabel: 'Assigned To',
    plannedHoursLabel: 'Planned Hours',
    dueDateLabel: 'Due on',
    refNumberLabel: 'Ref No.',
    showPlannedHours: true,
    showDueDate: true,
    showRefNumber: true,
    showApprovals: true,
    showTimeSummary: true,
    customFields: []
  };

  constructor(public requestService: RequestService) {}
}